import React from 'react'
import PropTypes from 'prop-types'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { milesToMeters, metersToMiles } from '@lib/conversions'
import { PillSelect } from './Refiners.styles'

const DistanceInput = (props) => {
  const {
    aroundRadius,
    setAroundRadius,
  } = props

  return (
    <PillSelect
      variant="outlined"
      value={aroundRadius}
      onChange={e => setAroundRadius(e.target.value)}
      displayEmpty
      IconComponent={KeyboardArrowDownIcon}
      renderValue={() => (aroundRadius ? `${metersToMiles(aroundRadius)} miles` : 'Distance')}
    >
      <MenuItem value={milesToMeters(15)}>15 miles</MenuItem>
      <MenuItem value={milesToMeters(25)}>25 miles</MenuItem>
      <MenuItem value={milesToMeters(50)}>50 miles</MenuItem>
      <MenuItem value={milesToMeters(200)}>200 miles</MenuItem>
    </PillSelect>
  )
}

DistanceInput.propTypes = {
  aroundRadius: PropTypes.number,
  setAroundRadius: PropTypes.func,
}

export default DistanceInput
